
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "button",
    },
    link: {
      type: [String, Object],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    button: {
      type: String,
      default: "black",
    },
    title: {
      type: String,
    },
    iconLeft: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonStyle() {
      let classes;

      if (this.button === "black") {
        classes = "md:hover:text-primary-green-200";
      } else classes = "text-white";

      return classes;
    },
  },
};
